// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading{
  display: flex; 
  flex-direction: column;
  align-items: center; 
  justify-content: center;
  /* background-color: white; */
  height: 5%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/styles/Loader.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,UAAU;EACV,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,kBAAkB;AACpB","sourcesContent":[".loading{\r\n  display: flex; \r\n  flex-direction: column;\r\n  align-items: center; \r\n  justify-content: center;\r\n  /* background-color: white; */\r\n  height: 5%;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  position: relative;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
